// extracted by mini-css-extract-plugin
export default {"titleArea":"title_titleArea__6CRAR","subtitleArea":"title_subtitleArea__AbYMz"};